























import Vue from 'vue'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options'
import { mapGetters } from 'vuex'
import { storeModuleName } from '@/views/App/Profile/store'
import SlideList from '@/components/modules/App/SlideList.vue'
import ActionCard from '@/components/modules/App/Profile/ActionCard.vue'
import { Action } from '@/requests/mainApi'

interface Data {
  viewCurrentActions: Action[]
  countInChunk: number
}

interface Methods {
  onSelectChunk: (value: any[]) => void
}

interface Computed {
  actions: Action[]
}

interface Props {}

export default Vue.extend({
  name: 'ActionsList',
  components: {
    SlideList,
    ActionCard
  },
  data () {
    return {
      viewCurrentActions: null,
      countInChunk: 4
    }
  },
  computed: {
    ...mapGetters(storeModuleName, ['actions'])
  },
  methods: {
    onSelectChunk (value: Action[]) {
      this.viewCurrentActions = value
    }
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
